/* eslint-disable no-param-reassign */

import { queryStrategy } from '../data/strategies';

const utmParameters = [
    { name: 'source', key: 'utm_source' },
];

const trackers = [
    { name: 'teester', consentRequired: false },
    { name: 'google', consentRequired: true },
];

export function makeTracking () {
    return {
        namespaced: true,
        state: {
            utm: {},
            consent: null,
        },
        getters: {
            consentKey (state, getters, rootState) {
                return `${rootState.solution.id}:tracking`;
            },
            /**
             * We only prompt the user for explicit tracking consent if GA is used
             */
            shouldAskConsent (state, getters, rootState) {
                const { GOOGLE_ANALYTICS_ID } = rootState.solution.config;
                return !!GOOGLE_ANALYTICS_ID && state.consent === null;
            },
        },
        mutations: {
            SET_UTM (state, utm) {
                state.utm = utm;
                console.log('[Tracking] UTM: ', { ...utm });
            },
            SET_CONSENT (state, consent) {
                state.consent = consent;
            },
        },
        actions: {
            async init ({ dispatch, state }) {
                await dispatch('updateTrackingUTM');
                await dispatch('updateTrackingConsent');
                // Enable trackers not needing consent
                await dispatch('initTrackers', false);
                // If stored consent is truthy, then enable trackers that require consent
                if (state.consent) {
                    await dispatch('initTrackers', true);
                }
            },
            async initTrackers ({ dispatch }, consentRequired) {
                const trackersToInit = trackers.filter((tracker) => tracker.consentRequired === consentRequired).map(({ name }) => name);
                console.log(`[Tracking] Initializing trackers (${consentRequired ? 'consent required' : 'no consent required'}: ${trackersToInit.join(', ')})`);
                await Promise.all(trackersToInit.map((tracker) => dispatch(`${tracker}/init`)));
            },
            async acceptTracking ({ commit, getters, dispatch }) {
                localStorage.setItem(getters.consentKey, JSON.stringify(true));
                commit('SET_CONSENT', true);
                await dispatch('initTrackers', true);
            },
            refuseTracking ({ commit, getters }) {
                localStorage.setItem(getters.consentKey, JSON.stringify(false));
                commit('SET_CONSENT', false);
            },
            async updateTrackingConsent ({ commit, getters, state }) {
                commit('SET_CONSENT', JSON.parse(localStorage.getItem(getters.consentKey)));
                console.log('[Tracking] Stored consent:', state.consent);
            },
            async updateTrackingUTM ({ commit }) {
                const utm = utmParameters.reduce((acc, { name, key }) => ({
                    ...acc,
                    [name]: queryStrategy(key),
                }), {});
                commit('SET_UTM', utm);
            },
        },
    };
}
